export const ADD_LOAD_COUNTER = 'ADD_LOAD_COUNTER';
export const SUB_LOAD_COUNTER = 'SUB_LOAD_COUNTER';
export const CLEAR_LOAD_COUNTER = 'CLEAR_LOAD_COUNTER';
